import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from './Card';

export default styled.div`
  font-weight: 500;
  justify-self: end;
  align-self: center;
  white-space: nowrap;

  ${upTo(breakpoint)`
    justify-self: start;
    font-size: 0.8rem;
    padding-top: 0.5rem;

    &:first-child {
      padding-top: 0;
    }
  `}
`;
